import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { BookOpen, ArrowRight, ChevronLeft } from "lucide-react";

export default function SubjectChapters() {
  const { subject, cls } = useParams();
  const [data, setData] = useState(null);
  const [progress, setProgress] = useState({});

  useEffect(() => {
    api.get("/syllabus").then((r) => setData(r.data[subject]));
    api.get("/profile/progress").then((r) => {
      const map = {};
      (r.data.chapters || []).forEach((c) => (map[c.chapter_id] = c));
      setProgress(map);
    });
  }, [subject]);

  const isHistory = subject === "history";
  const accent = isHistory ? "terracotta" : "sage";
  const accentClass = isHistory ? "text-brimi-terracotta" : "text-brimi-sage";
  const accentBg = isHistory ? "bg-brimi-terracotta/15" : "bg-brimi-sage/15";

  return (
    <div className="space-y-6">
      <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm text-brimi-navyText/70 hover:text-brimi-navy" data-testid="back-dashboard">
        <ChevronLeft size={16} /> Dashboard
      </Link>
      {data && (
        <>
          <div>
            <span className={`brimi-pill ${accentBg} ${accentClass}`}>Class {cls === "9" ? "IX" : "X"}</span>
            <h1 className="text-4xl sm:text-5xl font-heading font-bold text-brimi-navyText mt-2">{data.name}</h1>
            <p className="text-brimi-navyText/70 mt-1">{data.classes[cls].length} chapters · ICSE 2028 syllabus</p>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            {data.classes[cls].map((ch, i) => {
              const p = progress[ch.id];
              return (
                <Link
                  to={`/chapter/${ch.id}`}
                  key={ch.id}
                  data-testid={`chapter-${ch.id}`}
                  className="brimi-card p-5 stagger-in group"
                  style={{ animationDelay: `${i * 30}ms` }}
                >
                  <div className="flex items-start gap-4">
                    <div className={`w-10 h-10 rounded-xl grid place-items-center ${accentBg} ${accentClass} flex-shrink-0`}>
                      <BookOpen size={18} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs uppercase tracking-widest font-semibold text-brimi-navyText/55">{ch.section}</p>
                      <h3 className="font-heading font-semibold text-lg text-brimi-navyText mt-0.5">{ch.title}</h3>
                      <p className="text-sm text-brimi-navyText/65 mt-1 line-clamp-2">{ch.outline}</p>
                      <div className="flex items-center gap-3 mt-3 text-xs">
                        {p?.notes_viewed && <span className="brimi-pill bg-brimi-sage/15 text-brimi-sage">Notes ✓</span>}
                        {p?.last_mcq_total && (
                          <span className="brimi-pill bg-brimi-navy/10 text-brimi-navy">
                            MCQ: {p.last_mcq_score}/{p.last_mcq_total}
                          </span>
                        )}
                      </div>
                    </div>
                    <ArrowRight size={16} className="text-brimi-navyText/40 group-hover:translate-x-0.5 transition mt-2" />
                  </div>
                </Link>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
